document.addEventListener('DOMContentLoaded', function() {
    
    const notificationButtons = document.querySelectorAll('[data-toggle-notifications]');
    
    notificationButtons.forEach(button => {
        const modal = button.closest('.notifications-button').querySelector('[data-notifications-modal]');
        
        if (!modal) {
            return;
        }
        
        // Toggle modal on button click
        button.addEventListener('click', function(e) {
            e.preventDefault();
            toggleModal(modal);
        });
        
        // Close modal when clicking outside
        document.addEventListener('click', function(e) {
            if (!button.contains(e.target) && !modal.contains(e.target)) {
                closeModal(modal);
            }
        });
        
        // Close modal on escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                closeModal(modal);
            }
        });

        // Handle activate bonus button clicks
        modal.addEventListener('click', function(e) {
            if (e.target.classList.contains('activate-bonus-button')) {
                e.preventDefault();
                handleBonusActivation(e.target);
            }
        });
    });
    
    function toggleModal(modal) {
        if (modal.classList.contains('show')) {
            closeModal(modal);
        } else {
            openModal(modal);
        }
    }
    
    function openModal(modal) {
        // Close any other open notification modals
        document.querySelectorAll('.notifications-modal.show').forEach(openModal => {
            openModal.classList.remove('show');
        });
        
        modal.classList.add('show');
    }
    
    function closeModal(modal) {
        modal.classList.remove('show');
    }

    function handleBonusActivation(button) {
        
        const bonusId = button.getAttribute('data-bonus-id');
        const activationType = button.getAttribute('data-activation-type');
        const gameSlug = button.getAttribute('data-game-slug');
        
        // Disable button to prevent double-clicks
        button.disabled = true;
        button.textContent = notificationsAjax.i18n.activating;
        
        if (activationType === 'DEPOSIT') {
            // Redirect to deposit page with bonus code parameter
            const bonusCodeParam = bonusId ? `UserBonus:${bonusId}` : '';
            const depositUrl = bonusCodeParam 
                ? `/your-account/my-wallet/deposit/?bonus_code=${encodeURIComponent(bonusCodeParam)}`
                : '/your-account/my-wallet/deposit/';
            
            window.location.href = depositUrl;
            return;
        }
        
        if (activationType === 'MANUAL') {
            // Call the API to activate the bonus
            activateManualBonus(bonusId, gameSlug, button);
        } else {
            button.disabled = false;
            button.textContent = notificationsAjax.i18n.activateBonus;
        }
    }

    async function activateManualBonus(bonusId, gameSlug, button) {
        
        try {
            // Check if notificationsAjax is available
            if (typeof notificationsAjax === 'undefined') {
                throw new Error('notificationsAjax is not defined - script localization may have failed');
            }

            const formData = new FormData();
            formData.append('action', 'activate_bonus');
            formData.append('userBonusId', bonusId);
            formData.append('nonce', notificationsAjax.nonce);

            const response = await fetch(notificationsAjax.ajaxurl, {
                method: 'POST',
                body: formData
            });

            const result = await response.json();
            
            if (result.success) {
                
                // If we have a game slug, redirect to the game
                if (gameSlug) {
                    window.location.href = `/games/${gameSlug}/`;
                } else {
                    // Show success message without page refresh
                    button.textContent = notificationsAjax.i18n.activated;
                    button.style.color = 'white';
                    
                    // Remove the notification item after successful activation
                    setTimeout(() => {
                        const notificationItem = button.closest('.notification-item');
                        if (notificationItem) {
                            notificationItem.style.opacity = '0';
                            notificationItem.style.transform = 'translateX(100%)';
                            setTimeout(() => {
                                notificationItem.remove();
                                
                                // Check if there are any remaining notifications
                                const remainingItems = document.querySelectorAll('.notification-item');
                                if (remainingItems.length === 0) {
                                    // Show empty state
                                    const modal = button.closest('.notifications-modal');
                                    const modalContent = modal.querySelector('.notifications-modal__content');
                                    modalContent.innerHTML = `
                                        <div class="notifications-modal__empty">
                                            <div class="empty-icon">🔔</div>
                                            <h3>${notificationsAjax.i18n.allCaughtUp}</h3>
                                            <p>${notificationsAjax.i18n.bellBreak}<br>
                                            ${notificationsAjax.i18n.noBonuses}</p>
                                        </div>
                                    `;
                                    
                                    // Update notification count
                                    const notificationDot = document.querySelector('.notification-dot');
                                    if (notificationDot) {
                                        notificationDot.remove();
                                    }
                                    
                                    // Remove has-notifications class
                                    const notificationButton = document.querySelector('.notifications-button');
                                    if (notificationButton) {
                                        notificationButton.classList.remove('has-notifications');
                                    }
                                } else {
                                    // Update notification count
                                    const notificationDot = document.querySelector('.notification-dot');
                                    if (notificationDot) {
                                        const newCount = remainingItems.length;
                                        notificationDot.textContent = newCount;
                                    }
                                }
                            }, 300);
                        }
                    }, 1500);
                }
            } else {
                throw new Error(result.data.message || notificationsAjax.i18n.activationFailed);
            }
        } catch (error) {
            console.error(notificationsAjax.i18n.errorActivating, error);
            button.textContent = notificationsAjax.i18n.errorTryAgain;
            button.style.backgroundColor = '#dc3545';
            button.style.color = 'white';
            button.disabled = false;
            
            // Reset button after 3 seconds
            setTimeout(() => {
                button.textContent = notificationsAjax.i18n.activateBonus;
                button.style.backgroundColor = '';
                button.style.color = '';
            }, 3000);
        }
    }
});
